
import { InjectionToken } from '@angular/core';

export const IS_BROWSER = new InjectionToken('isBrowser');
export const IS_MOBILE = new InjectionToken('isMobile');
export const IS_MOBILE_SAFARI = new InjectionToken('isMobileSafari');
export const VIEWPORT_RESIZE = new InjectionToken('viewportResize');
export const LOCAL_STORAGE = new InjectionToken('localStorage');
